import React from 'react'

const errorPage = () => {
  return (
    <div>errorPage</div>
  )
}

export default errorPage